import type { ReactNode } from "react";
import { RequireAcl } from "@/components/RequireAcl";

export function RequirePersonalkostenAccess({ children }: { children: ReactNode }) {
  return <RequireAcl href="/personal/personalkosten.html">{children}</RequireAcl>;
}
